<template>
  <div>
    <div class="row">
      <div class="form-group col-12">
        <w-monaco language="json" :model="$schema.data" />
      </div>
    </div>

    <div class="mt-4">
      <button class="btn btn-primary float-left" @click="previousStep">
        Wstecz
      </button>

      <button class="btn btn-primary float-right" @click="submit">
        Dalej
      </button>
    </div>
  </div>
</template>

<script>
import { wizardStepMixin } from '@/mixins/wizardStep';
import schema from '@/schemas/procedure.schema';

// @vuese
// Krok ze szczegółowymi danymi procedury
export default {
  mixins: [wizardStepMixin('procedure', 1)],
  schema,
  methods: {
    // @vuese
    // Parsuje dane do JSONA przed zapisem
    prepareModel(model) {
      return { ...model, data: model.data && JSON.parse(model.data) };
    }
  }
};
</script>
